module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-cjdr.3d91f0bf.jpg";